import { listRiskMetrics, updateRuleTemplate } from './backend';

/** The fields `PUT /risk-analysis/rule-templates/:id` takes. */
const RULE_TEMPLATE_BODY_FIELDS = [
  'title',
  'description',
  'scoreFormula',
  'tags',
  'rules',
  'isActive',
  'defaultSeverity',
  'published',
];

/**
 * Delegates to the modules-backed `PUT /risk-analysis/rule-templates/:id`
 * route. Both callers (the two rule editors) submit their whole form state —
 * the template as `GET /:id` returned it, plus edits — and legacy AJV stripped
 * the rest. The route rejects unknown fields, so only its own are sent. Kept as
 * a thin re-export (rather than repointing the call sites) because both editors
 * are legacy views that are not Biome-clean.
 */
export function updateRiskAssessmentFormulaV3(id, body) {
  const picked = Object.fromEntries(
    RULE_TEMPLATE_BODY_FIELDS.filter(field => body?.[field] !== undefined).map(
      field => [field, body[field]],
    ),
  );
  return updateRuleTemplate(id, picked);
}

/**
 * Delegates to the modules-backed `/risk-analysis/metrics` route. Kept as a
 * thin re-export here (rather than repointing call sites): both callers
 * (`PrioritizationForm.jsx`) are legacy views that are not Biome-clean, so
 * editing them would drag an unrelated reformat and lint fixes into this change.
 */
export function getRiskAssessmentMetricsV3() {
  return listRiskMetrics();
}
